import React, { Component } from 'react'
import { Switch, Redirect } from 'react-router-dom';

import GuardianRoute from '../../shared/GuardianRoute';
import CatalogoClienteFiles from './files/CatalogoClienteFiles';

class CatalogoCliente extends Component {

  render() {
    return (
      <>
        <Switch>
          <Redirect from="/modulos/catalogo-cliente" to="/modulos/catalogo-cliente/archivos" exact />
          <GuardianRoute path="/modulos/catalogo-cliente/archivos"
            component={ CatalogoClienteFiles }
            can="catalogo.cliente.listar.archivos"
          />
        </Switch>
      </>
    )
  }
}

export default CatalogoCliente;